export const devConfiguration = {
  getLogin: "/admin/signIn",
  forgotPassword: "/admin/forgetPassword",
  verifyOtp: "/admin/verifyOTP",
  resetPassword: "/admin/resetPassword",
  getCMSoverview: "/admin/getCMS?type=overview",
  getCMSformatview: "/admin/getCMS?type=format_rules",
  updateCMS: "/admin/updateCMS",
  addVenue: "/admin/addVenue",
  getVenuelist: "/admin/viewVenueList",
  getVenueById: "/admin/viewVenue",
  updateVenue: "/admin/updateVenue",
  addNews: "/admin/createNews",
  getNewslist: "/admin/newsList",
  updateNewsState: "/admin/updateNewsStatus",
  updateNews: "/admin/updateNews",
  viewNews: "/admin/newsDetails",
  newsDetails: "/admin/newsDetails",
  addTeam: "/admin/addTeam",
  deleteNews: "/admin/deleteNews",
  newsList: "/user/newsList",
  userBannerList: "/user/bannerList",
  partnerStreamList: "/user/partnerStreamList",
  partnerUpdateList: "/user/getPartnerUpdateList",
  partnerUpdateTypeList: "/user/partnerUpdateTypeList",
  getContent: "/user/getContent",
  getSoundTrackBookingTicket: "/user/getSoundTrackBookingTicket",
  teamList: "/admin/viewTeamList",
  teamBlock: "/admin/updateTeamStatus",
  teamDelete: "/admin/deleteTeam",
  teamView: "/admin/viewTeam",
  updateTeam: "/admin/updateTeam",
  addBanner: "/admin/addBanner",
  bannerList: "/admin/bannerList",
  bannerDetails: "/admin/bannerDetails",
  updateBanner: "/admin/updateBanner",
  updatestatus: "/admin/banners/status",
  bannerUpdate: "/admin/updateBanner",
  viewBanner: "/admin/bannerList",
  deleteBanner: "/admin/banners",
  addFeaturedRestaurant: "/admin/addFeaturedRestaurant",
  saudiaCompetitionList: "/user/saudiaCompetitionList",
  saudiaCompetitionDetails: "/user/saudiaCompetitionDetails",
  saudiaMomentList: "/user/saudiaMomentList",
  saudiaMomentDetails: "/user/saudiaMomentDetails",
  cuisineList: "/admin/cuisineList",
  cuisineBlock: "/admin/updateCuisineStatus",
  addCuisine: "/admin/addCuisine",
  updateCuisine: "/admin/updateCuisine",
  dishCategoryList: "/admin/dishCategoryList",
  dishCategoryBlock: "/admin/updateDishCategoryStatus",
  dishCategoryDelete: "/admin/deleteDishCategory",
  addDishCategory: "/admin/addDishCategory",
  updateDishCategory: "/admin/updateDishCategory",
  mealTypeList: "/admin/mealTypeList",
  addMealType: "/admin/addMealType",
  updateMealType: "/admin/updateMealType",
  mealTypeStatusUpdate: "/admin/mealTypeStatusUpdate",
  customerList: "/admin/customers",
  customerStatusUpdate: "/admin/updateCustomerStatus",
  customerDetails: "/admin/customers",
  ingredientList: "/admin/ingridentList",
  ingredientStatusUpdate: "/admin/ingridentStatusUpdate",
  ingredientDelete: "/admin/deleteIngredient",
  addIngredient: "/admin/addIngrident",
  updateIngredient: "/admin/updateIngrident",
  allergiesList: "/admin/allergieList",
  addAllergies: "/admin/addAllergie",
  updateAllergies: "/admin/updateAllergie",
  allergiesStatusUpdate: "/admin/updateAllergyStatus",
  allergiesDelete: "/admin/deleteAllergy",
  restaurantList: "/admin/restaurentList",
  restaurantDetails: "/admin/restaurent",
  restaurantApprovalStatus: "/admin/restaurent",
  restaurantMenuCatalogue: "/admin/restaurent/menu-catalogue",
  menuCatalogueDetail: "/admin/restaurent/menu-catalogue-detail",
  contentManagement: "/admin/content-management",
  updateContentManagement: "/admin/content-management",
  winTicketList: "/user/winTicketList",
  userNewsDetails: "/user/newsDetails",
  userPartnerUpdateDetails: "/user/partnerUpdateDetails",
  addWinForm: "/user/addWinForm",
  formMasterList: "/user/formMasterList",
  storeUserForm: "/user/storeUserForm",
  quizList: "/user/quizeList",
  quizDetails: "/user/quizeDetails",
  submitUserPrediction: "/user/submitUserPrediction",
  surveyQuestionsList: "/user/surveyQuestionsList",
  submitPredictSurvey: "/user/submitPredictSurvey",
  getUserByToken: "/user/getUserByToken",
  updatePredictScore: "/user/updatePredictScore",
  countryList: "/user/countryList",
  getUserById: "/user/getUserById",
};
export const devAbiConfig = {};
